const shopify = "/fly-assets/logos/shopify-full.svg";
const woocommerce = "/fly-assets/logos/woo-commerce-full.svg";
const quickbooks = "/fly-assets/logos/quickbooks-full.svg";

export const supportedConnectorMap = {
  PrestaShop: "/fly-assets/logos/prestashop-full.svg",
  Shopify: shopify,
  Shopify2: shopify,
  Magento: "/fly-assets/logos/adobe-magento-full.svg",
  WooCommerce: woocommerce,
  WooCommerce2: woocommerce,
  Stripe: "/fly-assets/logos/stripe-full.svg",
  Amazon: "/fly-assets/logos/amazon-full.svg",
  BigCommerce: "/fly-assets/logos/big-commerce-full.svg",
  "Shopware 5": "/fly-assets/logos/shopware5-full.svg",
  "Google Analytics": "/fly-assets/logos/ga-full.svg",
  "Google Ads": "/fly-assets/logos/adwords-full.svg",
  "Facebook Ads": "/fly-assets/logos/meta-full.svg",
  "TikTok Ads": "/fly-assets/logos/tiktok-full.svg",
  "Oracle NetSuite": "/fly-assets/logos/netsuite-full.svg",
  Xero: "/fly-assets/logos/xero-full.svg",
  QuickBooks: quickbooks,
  "QuickBooks Online": quickbooks,
};
